import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Globais from "../../components/Globais";
import { validateToken } from "../../components/Globais";
import axios from "axios";
import { Button, Col, Flex, Row, Skeleton, message } from "antd";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;

const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;

  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
 
  #text {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  #button {
    width: 100%;
   
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #voltar {
    diplay: grid;
    grid-template: 50% 50% / 100%;
    align-items: center;
    justify-content: center;
    button {
      border: none;
      
      background: transparent;
      &:hover {
        cursor: pointer;
      }
  }

`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  width: 80%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (min-width: 400px) {
    font-size: 1.5rem;
  }
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
`;

const H3 = styled.h3`
text-align: left;

color: ${Globais.CorAzulBackGround};
font-size: 1rem;

@media (min-width: 400px) {
  font-size: 1.2rem;
  a {
    color: #2d3436;
  }
  a:hover {
    color: #636e72;
  }
`;
const H3lista = styled.h3`
text-align: left;

color: ${Globais.CorAzulBackGround};
font-size: 1rem;

@media (min-width: 400px) {
  font-size: 1.2rem;
`;

const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 80%;

  @media (min-width: 300px) {
    width: 50%;
  }
  @media (min-width: 400px) {
    width: 40%;
  }
  @media (min-width: 500px) {
    width: 35%;
  }

  @media (min-width: 600px) {
    width: 25%;
  }

  @media (min-width: 900px) {
    width: 15%;
  }
  @media (min-width: 1100px) {
    width: 8%;
  }
`;
const ImagemMaior = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;

  @media (min-width: 900px) {
    width: 90%;
  }
`;
const ImagemMenor = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  justify-self: center;
  @media (min-width: 500px) {
    width: 90%;
  }

  @media (min-width: 600px) {
    width: 80%;
  }
  @media (min-width: 700px) {
    width: 70%;
  }
  @media (min-width: 900px) {
    width: 50%;
  }
  @media (min-width: 1100px) {
    width: 40%;
  }
  @media (min-width: 1300px) {
    width: 30%;
  }
`;
const ImagemFechar = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 15%;
  justify-self: center;
  @media (min-width: 400px) {
    width: 10%;
  }

  @media (min-width: 500px) {
    width: 8%;
  }
  @media (min-width: 600px) {
    width: 6%;
  }

  @media (min-width: 700px) {
    width: 6%;
  }
  @media (min-width: 900px) {
    width: 5%;
  }
`;
const Pergunta = styled.button`

   border: none;
  width: 80%;
 height: 10%;
  background: transparent;
  &:hover {
    cursor: pointer;
  `;

export default function ViewInclusaoCidadeEstado() {
  // const [estados, setEstados] = useState<Estado[]>([]);
  // const [cidades, setCidades] = useState<Cidade[]>([]);
  // const [selectedEstado, setSelectedEstado] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [cidades, setCidades] = useState([{}]);
  const [paisesIBGE, setPaisesIBGE] = useState([]);
  const [processando, setProcessando] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const fetchDados = async () => {
      const Token = validateToken();
      if (Token) {
        if (Token.nda === 1) {
          setIsLoading(false);
        }else{
          document.location.href = "/sempermissao";
        }
      }
    };
    fetchDados();
  }, []);

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };

  const onSubmitInserirPais = async () => {
    const Token = validateToken();
    let paisesNaoIncluido = [{}];
    let paisesIncluido = [{}];
    if (Token) {
      const URLPais = `${Globais.DOMINIOBACK}/pais`;

      const responsePais = await axios.get(URLPais, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responsePais) {
        // setPaises(responsePais.data);
        const responsePaisIBGE = await fetch(
          "https://servicodados.ibge.gov.br/api/v1/localidades/paises"
        );

        (await responsePaisIBGE.json()).map(async (paisIBGE: any) => {
          let contador = 0;
          responsePais.data.map(async (pais: any) => {
            if (pais.nome === paisIBGE.nome) {
              console.log("Sim. Igual. Pula");
              contador++;
              paisesNaoIncluido.push(pais.nome);
            }
          });

          if (contador === 0) {
            try {
              let formPaisData = {
                origem: 0,
                nome: paisIBGE.nome,
                abreviacao: paisIBGE.nome.substr(0, 3).toUpperCase(),
              };
              const responseInserirPais = await axios.post(
                URLPais,
                formPaisData,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );
              if (responseInserirPais) {
                paisesIncluido.push(paisIBGE.nome);
                success("Países regularizados com sucesso!");
              }
            } catch (e) {
              console.log(e);
            }
          }
        });
      }
    }
    console.log("paisesNaoIncluido");
    console.log(paisesNaoIncluido);
    console.log("paisesIncluido");
    console.log(paisesIncluido);
  };
  const onSubmitInserirEstados = async () => {
    onSubmitInserirPais();
    const Token = validateToken();
    let estadosNaoIncluido = [{}];
    let estadosIncluido = [{}];
    if (Token) {
      const URLEstado = `${Globais.DOMINIOBACK}/estado`;

      const responseEstado = await axios.get(URLEstado, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responseEstado) {
        // setEstadoes(responseEstado.data);
        const responseEstadoIBGE = await fetch(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
        );

        (await responseEstadoIBGE.json()).map(async (estadoIBGE: any) => {
          let contador = 0;
          responseEstado.data.map(async (estado: any) => {
            if (estado.nome === estadoIBGE.nome && estado.origem === 0) {
              console.log("Sim. Igual. Pula");
              contador++;
              estadosNaoIncluido.push(estado.nome);
            }
          });

          if (contador === 0) {
            // console.log("incluir " + estadoIBGE.nome);
            // console.log("incluir " + estadoIBGE.sigla);

            try {
              let formEstadoData = {
                origem: 0,
                paisId: 2,
                nome: estadoIBGE.nome,
                abreviacao: estadoIBGE.sigla,
              };
              const responseInserirEstado = await axios.post(
                URLEstado,
                formEstadoData,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );
              if (responseInserirEstado) {
                estadosIncluido.push(estadoIBGE.nome);
                success("Estados regularizados com sucesso!");
              }
            } catch (e) {
              console.log(e);
            }
          }
        });
      }
    }
    console.log("estadosNaoIncluido");
    console.log(estadosNaoIncluido);
    console.log("estadosIncluido");
    console.log(estadosIncluido);
  };
  const onSubmitInserirCidades = async () => {
    onSubmitInserirPais();
    onSubmitInserirEstados();
    const Token = validateToken();
    let cidadesNaoIncluido = [{}];
    let cidadesIncluido = [{}];
    let estadoId = 0;

    if (Token) {
      //busco todos estados que tenho no banco
      const URLEstado = `${Globais.DOMINIOBACK}/estado`;

      const responseEstado = await axios.get(URLEstado, {
        headers: { Authorization: Token.AuthStr },
      });

      //busco todas as cidades que tenho no banco
      const URLCidade = `${Globais.DOMINIOBACK}/cidade`;

      const responseCidade = await axios.get(URLCidade, {
        headers: { Authorization: Token.AuthStr },
      });

      if (responseCidade) {
        //busco todos os estados que tenho no IBGE
        const responseEstadoIBGE = await fetch(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
        );

        // para cada um do estado do IBGE eu faço o seguinte:
        (await responseEstadoIBGE.json()).map(async (estadoIBGE: any) => {
          //busco todas as cidades do IBGE desse estado
          const responseCidadeIBGE = await fetch(
            `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoIBGE.id}/municipios`
          );

          estadoId = 0;

          //para esse estado do IBGE eu busco no banco qual id do estado de mesmo nome

          //para cada cidade IBGE
          (await responseCidadeIBGE.json()).map(async (cidadeIBGE: any) => {
            let contador = 0;
            //verifico se ele existe no banco. Se não existir eu crio
            responseCidade.data.map(async (cidade: any) => {
              //essa cidade é do estado em questão?
              if (cidade.nome === cidadeIBGE.nome && cidade.origem === 0) {
                console.log("Sim. Igual. Pula");
                contador++;
                cidadesNaoIncluido.push(cidade.nome);
              }
            });
            if (contador === 0) {
              try {
                responseEstado.data.map((estado: any) => {
                  if (estado.nome === estadoIBGE.nome && estado.origem === 0) {
                    estadoId = estado.id;
                  }
                });
                let formCidadeData = {
                  origem: 0,
                  estadoId: estadoId,
                  nome: cidadeIBGE.nome,
                };

                const responseInserirCidade = await axios.post(
                  URLCidade,
                  formCidadeData,
                  {
                    headers: { Authorization: Token.AuthStr },
                  }
                );
                if (responseInserirCidade) {
                  cidadesIncluido.push(cidadeIBGE.nome);
                }
              } catch (e) {
                console.log(e);
              }
            }
          });
        });
        success("Cidades regularizadas com sucesso!");
      }

      const responseCidadeDepois = await axios.get(URLCidade, {
        headers: { Authorization: Token.AuthStr },
      });
      if (responseCidadeDepois) {
        setCidades(responseCidadeDepois.data);
      }
    }
    console.log("cidadesNaoIncluido");
    console.log(cidadesNaoIncluido);
    console.log("cidadesIncluido");
    console.log(cidadesIncluido);
  };

  return (
    <Container>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Flex vertical style={{ width: "100%" }}>
          <Row style={{ margin: 100 }}>
            <Col span={8}>
              <Button type="primary" onClick={onSubmitInserirPais}>
                Inserir paises
              </Button>
            </Col>
            <Col span={8}>
              <Button type="primary" onClick={onSubmitInserirEstados}>
                Inserir estados
              </Button>
            </Col>
            <Col span={8}>
              <Button type="primary" onClick={onSubmitInserirCidades}>
                Inserir Cidades
              </Button>
            </Col>
          </Row>
        </Flex>
      )}
    </Container>
  );
}
